<mat-dialog-content>
  <ng-container *ngComponentOutlet="cCodeOutletInjector; injector: cCodeComponentInjector"></ng-container>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button [mat-dialog-close]="true" class="tp-button tp-button--cancel">Close</button>
</mat-dialog-actions>